import { removeSelectedBox } from '@utils/map/object.draw';

/**
 * Remove the selected box of the object session. Nothing is announced: Ctrl/Cmd+Z
 * brings the box back (the removal is an entry of the undo history).
 *
 * @returns {() => boolean} runs the removal; false when no box was selected
 */
export const useRemoveSelectedBox = () => () => Boolean(removeSelectedBox());
